import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Compact toggle chip used for small binary or segmented selections.
 */
@Component({
  selector: 'app-chip-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    button {
      display: inline-flex; align-items: center;
      padding: 6px 14px; border-radius: 4px;
      font-size: 0.75rem; font-weight: 500; cursor: pointer;
      transition: background 0.12s, color 0.12s, border-color 0.12s;
      border: 1px solid rgb(var(--talos-ink-rgb) / 0.15);
      background: var(--talos-bg); color: var(--talos-ink);
    }
    button:hover:not(.active) { background: var(--talos-bg); }
    button.active {
      background: var(--talos-ink); color: var(--talos-bg);
      border-color: var(--talos-ink); font-weight: 600;
    }
  `],
  template: `
    <button type="button" [class.active]="active()" (click)="toggled.emit()">{{ label() }}</button>
  `,
})
export class ChipToggleComponent {
  /** Text displayed inside the chip. */
  readonly label  = input.required<string>();
  /** Whether the chip is currently selected. */
  readonly active = input<boolean>(false);
  /** Emits when the chip is clicked. */
  readonly toggled = output<void>();
}
